'use client';

import LandingPageRevamped from './landing/LandingPageRevamped';

export default function Home() {
  // Show landing page at root - works for both logged in and logged out users
  return <LandingPageRevamped />;
}
